import React from 'react';

// Assets
import processingFile from '@/images/design-system-v2/loading-state/processing-file.gif';

// Components
import ProgressBar from '@/views/components/common/ProgressBar';
import { FormattedMessageV2 } from '@/views/components/i18n';

// Hooks
import { useSimulatedProgress } from '@/hooks/useSimulatedProgress';

import { DEFAULT_STEP, I18N_BASE_PATH, MEDIUM_FILE_SIZE, PROCESSING_STEPS } from './constants';
import { getDurationByFileSize } from './utils';

type Props = {
  fileSize?: number;
  isProcessing: boolean;
};

/**
 * Multi-portfolio specific processing file component.
 * Progress simulation duration varies based on file size using easeOutQuad for smooth deceleration.
 * Step thresholds: 0-10% (Processing) → 10-50% (Finding) → 50-99% (Digging) → stalls at 99% if API takes longer.
 * If API completes before duration ends, progress jumps to 100%.
 */
const MultiPortfolioProcessingFile: React.FC<Props> = ({ fileSize, isProcessing }) => {
  const duration = getDurationByFileSize(fileSize ?? MEDIUM_FILE_SIZE);
  const { progress, currentStep } = useSimulatedProgress({
    steps: PROCESSING_STEPS,
    defaultStep: DEFAULT_STEP,
    duration,
    isActive: isProcessing,
  });

  return (
    <div className="processing-file">
      <img className="image" src={processingFile} alt="processing-file" />
      <FormattedMessageV2 className="title" toLocalize={`${I18N_BASE_PATH}.${currentStep}.Title`} />
      <FormattedMessageV2 className="subtitle" toLocalize={`${I18N_BASE_PATH}.${currentStep}.Body`} />
      <ProgressBar progress={progress} />
      <FormattedMessageV2 className="disclosure" toLocalize={`${I18N_BASE_PATH}.Disclosure`} />
    </div>
  );
};

export default MultiPortfolioProcessingFile;
